import { padEnd } from 'lodash';

export default {
  CLEAR_ALL: state => {
    state.currentTab = null;
    state.group = null;
    state.groupDetailCk = null;
    state.groupDetailId = null;
    state.groups = [];
    state.groupSettings = null;
    state.hasSelection = false;
    state.loginSubGroups = [];
    state.parentGroup = null;
    state.parentGroups = [];
    state.searchFilter = '';
    state.searching = false;
    state.searchResults = null;
    state.searchType = null;
    state.showSearch = false;
    state.subGroup = null;
    state.subGroupDetailCk = null;
    state.subGroups = [];
    state.tabs = ['parentGroup', 'group', 'subGroup'];
    state.tabsVisible = true;
    state.userHasOneParent = false;
    state.userHasTripleOnes = false;
  },
  CLEAR_CURRENT_TAB: state => (state.currentTab = null),
  CLEAR_GROUP: state => (state.group = null),
  CLEAR_GROUP_DETAIL_CK: state => (state.groupDetailCk = null),
  CLEAR_GROUP_DETAIL_ID: state => (state.groupDetailId = null),
  CLEAR_GROUPS: state => (state.groups = []),
  CLEAR_GROUP_SETTINGS: state => (state.groupSettings = null),
  CLEAR_LOGIN_SUBGROUPS: state => (state.loginSubGroups = []),
  CLEAR_PARENT_GROUP: state => {
    // console.log('CLEAR_PARENT_GROUP');
    state.parentGroup = null;
  },
  CLEAR_PARENT_GROUPS: state => (state.parentGroups = []),
  CLEAR_SEARCH: state => {
    state.searchName = '';
    state.searchId = '';
  },
  CLEAR_SEARCHING: state => (state.searching = false),
  CLEAR_SEARCH_RESULTS: state => (state.searchResults = null),
  CLEAR_SHOW_SEARCH: state => (state.showSearch = false),
  CLEAR_SUB_GROUP: state => {
    console.log(`CLEAR_SUB_GROUP`);
    state.subGroup = null;
  },
  CLEAR_SUB_GROUP_DETAIL_CK: state => (state.subGroupDetailCk = null),
  CLEAR_SUB_GROUPS: state => (state.subGroups = []),

  SET_CURRENT_TAB: (state, tab) => (state.currentTab = tab),
  SET_GROUP: (state, group) => {
    // console.log(`SET GROUP`, group);
    state.group = group;
  },
  SET_GROUP_DETAIL_CK: (state, groupDetailCk) =>
    (state.groupDetailCk = groupDetailCk),
  SET_GROUP_DETAIL_ID: (state, groupDetailId) =>
    (state.groupDetailId = groupDetailId),
  SET_GROUP_SETTINGS: (state, groupSettings) =>
    (state.groupSettings = groupSettings),
  SET_GROUPS: (state, groups) => {
    // console.log(`SET_GROUPS`, groups);
    state.groups = [...groups];
  },
  // SET_LOGIN_SUBGROUPS: (state, loginSubGroups) => state.loginSubGroups = loginSubGroups,
  SET_PARENT_GROUP: (state, parentGroup) => {
    // console.log(`SET PARENT GROUP`, parentGroup);
    state.parentGroup = parentGroup;
  },
  SET_PARENT_GROUPS: (state, parentGroups) => {
    // console.log(`SET PARENT GROUPS`, parentGroups);
    state.parentGroups = [...parentGroups];
  },
  SET_SEARCH_ID: (state, filter) => (state.searchId = filter),
  SET_SEARCH_NAME: (state, filter) => (state.searchName = filter),
  SET_SEARCHING: state => (state.searching = true),
  SET_SEARCH_RESULTS: (state, searchResults) =>
    (state.searchResults = searchResults),
  SET_SHOW_SEARCH: (state, showSearch) => (state.showSearch = showSearch),
  SET_SUB_GROUP: (state, subGroup) => {
    console.log(`SET_SUB_GROUP`, subGroup);
    state.subGroup = subGroup;
  },
  SET_SUB_GROUP_DETAIL_CK: (state, subGroupDetailCk) =>
    (state.subGroupDetailCk = subGroupDetailCk),
  SET_SUB_GROUPS: (state, subGroups) => {
    // console.log(`SET_SUB_GROUPS`, subGroups);
    state.subGroups = [...subGroups];
  }
};
